<template>
  <table border="1" class="plan-table">
    <tr>
      <template v-for="(item, index) in tableColunms" :key="index">
        <th>
          {{ item }}
        </th>
      </template>
    </tr>

    <template v-for="(item, index) in props.tableData.data" :key="index">
      <tr>
        <td rowspan="3" class="wbs">{{ item.wbs }}</td>
        <td rowspan="3" class="type">{{ item.type }}</td>
        <td rowspan="3" class="description">{{ item.description }}</td>
        <td rowspan="3" class="username">{{ item.username }}</td>
        <td class="execute">
          <a-button
            size="small"
            @click="handleUpdateRecord(item, 'release')"
            :disabled="user.nickName !== item.username"
            >执行</a-button
          >
        </td>
        <td rowspan="3" class="executor">{{ item.executor }}</td>
        <td class="start-time">{{ item.releaseStartTime }}</td>
        <td class="end-time">{{ item.releaseEndTime }}</td>
        <td rowspan="3" class="completion-degree">
          {{ item.completionDegree }}
        </td>
        <td rowspan="3" class="download">
          <a-button v-if="item.fileLink" size="small">下载</a-button>
        </td>

        <td rowspan="3" class="assistance-needed">
          {{ item.assistanceNeeded }}
        </td>

        <td rowspan="3" class="action">
          <a-space>
            <a-button
              @click="handleDeleteRecord(item)"
              size="small"
              type="danger"
              >删除</a-button
            >
            <a-button
              @click="handleUpdateRecord(item, 'edit')"
              size="small"
              type="primary"
              >编辑</a-button
            >
          </a-space>
        </td>
      </tr>

      <tr>
        <td class="execute">
          <a-button size="small" @click="handleUpdateRecord(item, 'scheduled')"
            >计划</a-button
          >
        </td>
        <td class="start-time">{{ item.scheduledStartTime }}</td>
        <td class="end-time">{{ item.scheduledEndTime }}</td>
      </tr>

      <tr>
        <td class="execute">
          <a-button
            size="small"
            @click="handleUpdateRecord(item, 'actualRelease')"
            >实际</a-button
          >
        </td>
        <td class="start-time">{{ item.actualReleaseStartTime }}</td>
        <td class="end-time">{{ item.actualReleaseEndTime }}</td>
      </tr>
    </template>
  </table>
</template>

<script>
import { defineComponent, watch } from "vue";
import { deleteProblemRequirementSchedule } from "@/request/view/project";
import { tableColunms } from "@/views/rdmanagement/components/demand/options";
import { showModal } from "@/views/repairprogress/serve/modal";
import { Toast } from "@/utils";
import { useStore } from "vuex";

export default defineComponent({
  props: {
    tableData: Object,
  },
  setup(props, context) {
    const user = useStore().state.user.user;

    const handleDeleteRecord = (record) => {
      showModal({
        title: "确定删除该记录？",
        toastText: "确定",
        success: () => {
          deleteProblemRequirementSchedule([record.id]).then((res) => {
            let type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            context.emit("updateTable");
          });
        },
      });
    };

    const handleUpdateRecord = (record, type) => {
      context.emit("handleUpdateRecord", record, type);
    };

    // watch(
    //   () => props.tableData,
    //   (val) => {
    //     console.log(val, "这是什么");
    //   },
    //   {
    //     immediate: true,
    //     deep: true,
    //   }
    // );
    return {
      props,
      user,
      tableColunms,
      handleUpdateRecord,
      handleDeleteRecord,
    };
  },
});
</script>

<style lang="less" scoped>
.theme {
  text-align: center;
  font-size: 20px;
  letter-spacing: 1px;
  font-weight: 600;
}
.plan-table {
  margin: 30px auto;
  th,
  td {
    padding: 5px 10px;
    text-align: center;
  }
}
.tasks-title {
  width: 120px;
}

.wbs {
  width: 120px;
}
.type {
  width: 80px;
}
.description {
  width: 240px;
}
.username {
  width: 80px;
}
.execute {
  width: 80px;
}
.executor {
  width: 90px;
}
.start-time {
  width: 120px;
}
.end-time {
  width: 120px;
}
.completion-degree {
  width: 90px;
}
.assistance-needed {
  width: 200px;
}
.download {
  width: 90px;
}
</style>
